import { Record, List } from "immutable";
import User from "./record.user.jsx";

export const MEMBER_PERMISSIONS = {
  STRICT: `strict`,
  COLLABORATIVE: `collaborative`,
};

const ProjectRecord = Record({
  id: undefined,
  project_number: undefined,
  name: ``,
  members: List(),
  leader_id: undefined,
  based_on_id: undefined,
  based_on_type: undefined,
  body: ``,
  body_formatted: ``,
  budget: undefined,
  budget_type: undefined,
  budgeting_interval: "",
  category_id: undefined,
  class: `Project`,
  company_id: undefined,
  completed_by_id: undefined,
  completed_by_name: "",
  completed_by_email: "",
  completed_on: undefined,
  count_discussions: 0,
  count_files: 0,
  count_notes: 0,
  count_tasks: 0,
  count_time_records: 0,
  created_by_id: undefined,
  created_by_name: "",
  created_by_email: "",
  created_on: undefined,
  currency_id: undefined,
  email: undefined,
  is_client_reporting_enabled: false,
  is_completed: false,
  is_tracking_enabled: false,
  is_billable: true,
  members_can_change_billable: true,
  task_estimates_enabled: true,
  is_estimate_visible_to_subcontractors: true,
  show_task_estimates_to_clients: false,
  is_trashed: false,
  label_id: undefined,
  last_activity_on: undefined,
  task_labels: List(),
  template_id: undefined,
  trashed_by_id: undefined,
  trashed_on: undefined,
  updated_by_id: undefined,
  updated_on: undefined,
  url_path: undefined,
  is_sample: false,
  file_size: 0,
  member_permissions: MEMBER_PERMISSIONS.COLLABORATIVE,
  subscribers: List(),
});

class Project extends ProjectRecord {
  isLeader(user) {
    if (user instanceof User) {
      return user.id === this.leader_id;
    }

    return false;
  }

  isMember(user) {
    if (user instanceof User) {
      return this.members.indexOf(user.id) > -1;
    }
    return false;
  }
}

export default Project;
